import * as z from 'zod'
import { ValidationMessageKeys } from 'src/Configuration/validation/translation-keys'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { LONG_FIELD_LENGTH, SHORT_FIELD_LENGTH, ZIP_CODE_FIELD_LENGTH } from 'src/Configuration/validation/consts'

interface ReturnType {
  installationAddressFormSchema: z.Schema
}

/**
 * Hook to validate installation address form with zod
 */
const useValidateInstallationAddressForm = (): ReturnType => {
  const { t } = useCustomTranslation()
  const requiredMessage = t(ValidationMessageKeys.required)
  const tooLongMessage = (max: number): string => t(ValidationMessageKeys.tooLong, { value: max })

  const installationAddressFormSchema = z.object({
    streetName: z
      .string({ message: requiredMessage })
      .min(1, { message: requiredMessage })
      .max(LONG_FIELD_LENGTH, { message: tooLongMessage(LONG_FIELD_LENGTH) }),
    streetNumber: z
      .string({ message: requiredMessage })
      .min(1, { message: requiredMessage })
      .max(SHORT_FIELD_LENGTH, { message: tooLongMessage(SHORT_FIELD_LENGTH) }),
    zip: z
      .string({ message: requiredMessage })
      .min(1, { message: requiredMessage })
      .max(ZIP_CODE_FIELD_LENGTH, { message: tooLongMessage(ZIP_CODE_FIELD_LENGTH) }),
    city: z
      .string({ message: requiredMessage })
      .min(1, { message: requiredMessage })
      .max(LONG_FIELD_LENGTH, { message: tooLongMessage(LONG_FIELD_LENGTH) }),
    countryCode: z
      .string({ message: requiredMessage })
      .min(1, { message: requiredMessage })
      .max(SHORT_FIELD_LENGTH, { message: tooLongMessage(SHORT_FIELD_LENGTH) }),
  })

  return { installationAddressFormSchema }
}

export default useValidateInstallationAddressForm
